// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DownSquareTwoToneSvg from "@ant-design/icons-svg/es/asn/DownSquareTwoTone";
import AntdIcon from '../components/AntdIcon';

var DownSquareTwoTone = function DownSquareTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: DownSquareTwoToneSvg
  }));
};

DownSquareTwoTone.displayName = 'DownSquareTwoTone';
export default React.forwardRef(DownSquareTwoTone);